module.exports = __webpack_public_path__ + "img/Desk Stationary A05.95d72288.jpg";